<script setup lang="ts">
import { RouterView, useRoute, useRouter } from 'vue-router';
import { useHead } from '@unhead/vue';
import GnbHeader from '@src/components/layouts/GnbHeader.vue';
// import LnbMenus from '@src/components/layouts/LnbMenus.vue';
import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch } from 'vue';
// import { useCommonStore } from './stores/common';
// import { MENUS } from './constants-keys';
import type { IMenuItem } from './types';
import { useCommonStore } from './stores/common';

const route = useRoute();
const router = useRouter();
const menus = ref<IMenuItem[]>();
const screenSize = { width: 675, height: 1200 };
const commonStore = useCommonStore();

const isLoginPage = computed(() => route.fullPath === '/admin/login');
// const isAdminPage = computed(() => route.fullPath.includes('/admin') && route.fullPath !== '/admin/login');
const isAdminPage = ref<boolean>(route.fullPath.includes('/admin') || route.fullPath === '/');

useHead({
  title: '국립생태원',
  meta: [
    {
      name: 'description',
      content: '국립생태원 성격 유형 검사 콘텐츠',
    },
  ],
});
// const store = useCommonStore();
// const activeMenu = computed(() => store.activeMenu);
const resize = () => {
  const t = setTimeout(() => {
    const appEl = document.getElementById('app');

    if (!appEl) return;
    // admin 페이지 일때 콘텐츠 용 resize 해제
    if (isAdminPage.value) return;

    // 화면의 비율을 기준으로 스케일 계산
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    // 비율이 1080x1920 기준으로 조정
    const widthRatio = windowWidth / 1080;
    const heightRatio = windowHeight / 1920;

    // 스케일을 정하기 위한 기준: 작은 비율을 선택하여 비율 유지
    const scale = Math.min(widthRatio, heightRatio);

    // 배경 및 스타일 설정
    document.body.style.background = '';
    appEl.style.width = '1080px';
    appEl.style.height = '1920px';
    appEl.style.position = 'absolute';
    appEl.style.top = '50%';
    appEl.style.left = '50%';
    // appEl.style.transform = `translate(-50%, -50%) scale(${scale})`;

    // 애니메이션 프레임을 사용하여 스타일을 업데이트
    requestAnimationFrame(() => {
      // resize 로드되기 전까지 app은 display none
      appEl.style.display = 'block'; // 요소를 보이게 함
      appEl.style.transform = `translate(-50%, -50%) scale(${scale})`;
    });
    clearTimeout(t);
  }, 0);
};

onMounted(() => {
  if (typeof window !== 'undefined') {
    // window.addEventListener('resize', resize);
    // resize();
  }

  if (route.fullPath === '/') {
    router.replace('/admin');
  }
});

onUnmounted(() => {
  // window.removeEventListener('resize', resize);
});
</script>

<template>
    <div v-if="commonStore.isLoading" class="loading-dim"></div>
	<div v-if="commonStore.isLoading" class="loading-bg">
		<div ref="loader" class="loader"></div>
	</div>
  <gnb-header v-if="isAdminPage && !isLoginPage" />
  <div class="layout-body">
    <div class="layout-content-body-wrapper">
      <section class="layout-content-body">
        <router-view :key="$route.path" />
      </section>
    </div>
  </div>
</template>

<style lang="scss">
@import '@src/assets/css/app.scss';
</style>
